export const paymentMethodReturnWarning = 'This payment method had an ACH return and needs to be re-entered.';

export const isPaymentMethodUsable = method => !!method && method.isActive !== false && !method.achReturnedAt && !method.removedAt;

export const preferredPaymentMethodID = (methods = [], selectedID) => {
    const selected = methods.find(method => (method.paymentMethodID || method.id) === selectedID);
    const method = isPaymentMethodUsable(selected) ? selected : methods.find(isPaymentMethodUsable);
    return method?.paymentMethodID || method?.id || null;
};
